/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  axios.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:25
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import { PluginObject, VueConstructor } from "vue";
import { AxiosInstance } from "axios";

const VueAxios: PluginObject<any> = {
  vm: {},
  install(Vue: VueConstructor, instance: AxiosInstance) {
    if (this.installed) {
      return;
    }
    this.installed = true;

    if (!instance) {
      // console.error('You have to install axios')
      return;
    }

    Vue.axios = instance;

    Object.defineProperties(Vue.prototype, {
      axios: {
        get: function get() {
          return instance;
        },
      },
      $http: {
        get: function get() {
          return instance;
        },
      },
    });
  },
};

export { VueAxios };
